import React from 'react'

const AiInsights = () => {
  return (
    <div>
         <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            AI-powered insights on digital solutions and talent partnership services
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center space-y-4">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-orange-600 font-bold text-2xl">95%</span>
            </div>
            <h3 className="text-xl font-semibold text-slate-900">95% cost savings</h3>
            <p className="text-slate-600">
              Appnexts talent augmentation consulting team delivers 95% cost savings compared with in-house hires.
            </p>
          </div>

          <div className="text-center space-y-4">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-blue-600 font-bold text-2xl">44%</span>
            </div>
            <h3 className="text-xl font-semibold text-slate-900">44% innovation ready</h3>
            <p className="text-slate-600">
              Nearly 44% of businesses report that digital transformation initiatives help increase why are not prepared
              to understand it.
            </p>
          </div>

          <div className="text-center space-y-4">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-green-600 font-bold text-2xl">89%</span>
            </div>
            <h3 className="text-xl font-semibold text-slate-900">89% more success</h3>
            <p className="text-slate-600">
              Companies experience 89% higher reliability and performance when they partner with us to outsource their
              competencies.
            </p>
          </div>
        </div>
      </div>
    </section>
    </div>
  )
}

export default AiInsights